export default "__VITE_ASSET__qmhWK8oS__"